module.exports = __webpack_public_path__ + "img/ResearchIcon2.73655ec8.png";